import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { fetchBlobFile } from "../../utils/FetchBlobFile";
import { FaEye, FaDownload } from 'react-icons/fa';
import Spinner from 'react-bootstrap/Spinner';
import Container from 'react-bootstrap/Container';


const PdfViewerModal = ({ fileName, clientKey }) => {
    const [show, setShow] = useState(false);
    const [pdfUrl, setPdfUrl] = useState("");

    // Función para obtener y mostrar el PDF en el modal
    const handleShowPdf = async () => {
        setShow(true);
        setPdfUrl("");
        try {
            const fileBlob = await fetchBlobFile(fileName, clientKey);
            const fileUrl = URL.createObjectURL(fileBlob);
            setPdfUrl(fileUrl);
        } catch (error) {
            console.error("Error al cargar el PDF:", error);
        }
    };

    return (
        <>
            {/* Botón para abrir el modal */}
            <Button variant="danger" className="fab-button" onClick={handleShowPdf}>
                <FaEye size={20} />
            </Button>

            {/* Modal de Bootstrap */}
            <Modal show={show} onHide={() => setShow(false)} size="xl" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Vista Previa del Documento</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {pdfUrl ? (
                        <iframe
                            src={`${pdfUrl}#toolbar=0`}
                            title="PDF Viewer"
                            width="100%"
                            height="600px"
                            style={{ border: "none" }}
                        ></iframe>
                    ) : (
                        <Container style={{ height: "33rem" }} className="align-items-center align-middle d-flex justify-content-center">
                            <Spinner variant="primary" animation="border" role="status" style={{ width: "6rem", height: "6rem" }}>
                                <span className="visually-hidden">Loading...</span>
                            </Spinner>
                        </Container>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShow(false)}>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default PdfViewerModal;
